import {Api} from "./api"

export default class UserApi extends Api {
    constructor() {
        super("/user");
    }

    // async login(username: string, password: string) {
    //     const res = await this.call("/login", {username, password});
    //     if (res?.errno == 0) {
    //         return res?.data as User;
    //     }
    //     return null
    // }

    async getAccessToken(code: string) {
        return await this.call("/get_access_token", {code});
    }

    // async register(username: string, password: string, phone: string, email: string, wpsID: string) {
    //     return await this.call("/register", {username, password, phone, email, wpsID});
    // }

    async update(userID: number, phone: string, email: string, wpsID: string) {
        return await this.call("/update", {userID, phone, email, wpsID});
    }

    async getUser(username: string) {
        return await this.call("/get_user", {username});
    }

    async getAllUser() {
        return await this.call("/list_user");
    }


}